import React, { useContext } from 'react';
import { ScrollView, View } from 'react-native';
import PropTypes from 'prop-types';
import Button from '../../common/Button';
import { StyledWebView } from '../../common/StyledWebView';
import { H4 } from '../../text';
import LayoutContext, { MODERN_LAYOUT_COLLAPSE_WIDTH } from '../../../contexts/Layout';

const STYLED_WEB_VIEW_ID = 'tabbedContainerItem';

export const TabbedContainerItem = ({
    buttonLabel,
    description,
    externalLink,
    followContentLink = async () => {},
    heading,
    link,
    nodeTypeAlias = 'TabbedContainerItem',
    textColor,
    width
}) => {
    const { layout } = useContext(LayoutContext);

    const narrowWrapperStyle = {
        marginHorizontal: layout.styleGuide.spacer1,
        marginVertical: layout.styleGuide.spacer2
    };

    const wideWrapperStyle = {
        borderLeftWidth: layout.device.isMobile ? 0 : 1,
        borderLeftColor: textColor,
        flex: 1,
        paddingLeft: layout.styleGuide.spacer1
    };

    const getStyledWebView = () => {
        if (layout.device.os.equals('web')) {
            if (layout.device.isMobile) {
                return (
                    <View style={{ flex: 1 }}>
                        <div
                            style={{ color: textColor, fontFamily: layout.styleGuide.p1.fontFamily, fontSize: layout.styleGuide.p1.fontSize }}
                            dangerouslySetInnerHTML={{ __html: description }}
                        />
                    </View>
                );
            } else {
                return (
                    <ScrollView showsVerticalScrollIndicator={false}>
                        <div
                            style={{ color: textColor, fontFamily: layout.styleGuide.p1.fontFamily, fontSize: layout.styleGuide.p1.fontSize, maxWidth: '80%' }}
                            dangerouslySetInnerHTML={{ __html: description }}
                        />
                    </ScrollView>
                );
            }
        } else {
            return (
                <StyledWebView
                    textProps={{ style: { color: textColor, marginRight: layout.styleGuide.indent } }}
                    html={description}
                    nodeId={STYLED_WEB_VIEW_ID}
                    width={width}
                />
            );
        }
    };

    return (
        <View dataSet={{ umbracoComponentName: nodeTypeAlias }}>
            <View style={width <= MODERN_LAYOUT_COLLAPSE_WIDTH ? narrowWrapperStyle : wideWrapperStyle}>
                <View style={{ height: width * 0.35, width: layout.device.isMobile ? width : width * 0.7, justifyContent: 'center' }}>
                    {!layout.device.isMobile && !layout.device.isTablet && (
                        <H4 style={{ color: textColor, marginBottom: layout.styleGuide.spacer4, minHeight: 50, maxHeight: 100 }} text={heading} />
                    )}
                    {!!description && getStyledWebView()}
                    {!!buttonLabel && (
                        <Button
                            disabled={false}
                            onPress={async () => await followContentLink(link.isExternal, link.internalKey, link.externalUrl || externalLink)}
                            style={{ marginTop: 10, backgroundColor: 'transparent', borderColor: textColor, width: '50%' }}
                            text={buttonLabel}
                            textStyle={{ color: textColor }}
                        />
                    )}
                </View>
            </View>
        </View>
    );
};

TabbedContainerItem.propTypes = {
    buttonLabel: PropTypes.string,
    description: PropTypes.string,
    externalLink: PropTypes.string,
    heading: PropTypes.string,
    link: PropTypes.shape({
        externalUrl: PropTypes.string,
        isExternal: PropTypes.bool,
        internalKey: PropTypes.string
    }),
    textColor: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
